// extracted by mini-css-extract-plugin
export default {"containerVerticalBar":"VerticalBar_containerVerticalBar__0vgvZ","containerHorizontalBar":"VerticalBar_containerHorizontalBar__pPPyc"};